module.exports = __webpack_public_path__ + "img/丽江2_1.f5a3ef60.jpg";